import 'infinite-scroll/dist/infinite-scroll.pkgd'

let loadMore = jQuery('.load-more')

if (loadMore.length > 0) {

    let iSc = jQuery('.repeater__holder').infiniteScroll({
        path: '.load-more__button',
        checkLastPage: true,
        append: '.repeater',
        loadOnScroll: false,
        scrollThreshold: false,
        button: '.load-more',
        status: '.page-load-status'
    })

    var elementsCount

    iSc.on('append.infiniteScroll', (response, path, items) => {
        jQuery('.repeater').find('img').each((index, img) => {
            img.outerHTML = img.outerHTML
        })

        if( jQuery('html').data('whatinput') == 'keyboard' ){
            elementsCount = elementsCount + 1
            jQuery( '.repeater__holder .block:nth-child('+elementsCount+') .block__title a' ).focus()
        }

    })

    iSc.on('request.infiniteScroll', (event, path) => {
        elementsCount = jQuery( '.repeater__holder' ).children().length
    })

}
